export const ACTION_TYPES = {
	ADD_REQUESTEES_BY_FILTER: 'ADD_REQUESTEES_BY_FILTER',
	ADVANCE: 'SUBMIT_FORM',
	CLEAR_DATA: 'CLEAR_DATA',
	DELETE_ROW: 'DELETE_ROW',
	DIRECT_REPORTS: 'SET_DIRECT_REPORTS',
	FILTER_ROWS: 'FILTER_ROWS',
	HEADER_SORT: 'SORT_BY_HEADER',
	INIT: 'INIT',
	LOADING: 'SET_LOADING',
	ROWS: 'SET_ROWS',
	ROWS_INDEX: 'INDEX_ROWS',
	ROW_TOGGLE: 'TOGGLE_ROW',
	ROWS_TOGGLE: 'TOGGLE_ROWS',
	ROW_UPDATE: 'UPDATE_ROW_VALUE',
};

export const ACTION_FILTER_TYPES = {
	INVALID_INCLUDE: 'INVALID_INCLUDE',
	INVALID_EXCLUDE: 'INVALID_EXCLUDE',
	VALID_INCLUDE: 'VALID_INCLUDE',
	VALID_EXCLUDE: 'VALID_EXCLUDE',
};
